import React from 'react';
import {IconToggle, Text} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {classes} from './BottomFoldableSummarySection.st.css';
import {ChevronDown, ChevronUp, Error as ErrorIcon} from '@wix/wix-ui-icons-common/on-stage';
import {isLineItemErrorViolationExist} from '../../LineItem/LineItem.utils';
import {BiFoldableSummaryAction, BiMobilePosition} from '../../../../../domain/utils/bi.util';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../common/constants';

export enum BottomFoldableSummarySectionDataHooks {
  root = 'BottomFoldableSummarySectionDataHooks.root',
  content = 'BottomFoldableSummarySectionDataHooks.content',
  chevronUp = 'BottomFoldableSummarySectionDataHooks.chevronUp',
  chevronDown = 'BottomFoldableSummarySectionDataHooks.chevronDown',
  errorIcon = 'BottomFoldableSummarySectionDataHooks.errorIcon',
}

export interface BottomFoldableSummarySectionProps {
  onClick: ({isOpen}: {isOpen: boolean}) => void;
  isOpen: boolean;
}

export const BottomFoldableSummarySection = ({onClick, isOpen}: BottomFoldableSummarySectionProps) => {
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  const {
    checkoutStore: {cart, shouldShowViolations, onMobileFoldableSummaryToggle, cartSummary},
  } = useControllerProps();

  const shouldShowErrorIcon = Boolean(
    !!cart.noItemsError ||
      !!cart.hasOutOfStockLineItems ||
      (cartSummary && shouldShowViolations && isLineItemErrorViolationExist(cartSummary.violations))
  );

  const toggle = () => {
    onClick({isOpen: !isOpen});
    onMobileFoldableSummaryToggle(BiMobilePosition.bottom, {
      action: isOpen ? BiFoldableSummaryAction.close : BiFoldableSummaryAction.open,
    });
  };

  return (
    <button
      type={'button'}
      data-hook={BottomFoldableSummarySectionDataHooks.root}
      className={checkoutUIRevampOrderSummary ? classes.root : classes.rootOld}
      onClick={toggle}
      aria-expanded={isOpen}>
      <Text data-hook={BottomFoldableSummarySectionDataHooks.content} className={classes.textWrapper}>
        {shouldShowErrorIcon && (
          <ErrorIcon data-hook={BottomFoldableSummarySectionDataHooks.errorIcon} className={classes.errorIcon} />
        )}
        {isOpen
          ? localeKeys.checkout.mobile.hideItems.label({number: cart.numberOfItems})
          : localeKeys.checkout.mobile.showItems.label({number: cart.numberOfItems})}
      </Text>
      <IconToggle
        icon={<ChevronDown data-hook={BottomFoldableSummarySectionDataHooks.chevronDown} />}
        checkedIcon={<ChevronUp data-hook={BottomFoldableSummarySectionDataHooks.chevronUp} />}
        checked={isOpen}
      />
    </button>
  );
};
